import { render } from "./WsRdv.vue?vue&type=template&id=22532a42"
import script from "./WsRdv.vue?vue&type=script&lang=js"
export * from "./WsRdv.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__